/**
 * A value that follows `value` only after it has been still for `delayMs` (a search box that asks the
 * server once per pause, not once per key). The delay is the caller's, so a test injects its own and
 * never sleeps (checklist 16). A change back to the settled value cancels the pending one.
 */

import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(value);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);
  return settled;
}
